<template>
  <div style="margin-top: 30px;">
    <el-row style="margin-top: 30px;">
      <el-col :span="20">
        <div style="margin-bottom: 30px">
          <i class="iconfont icon-navicon-bmfa formtitle" />
          <span class="formtitle">{{$t("message.partnerTarget")}}：</span>
        </div>
      </el-col>
      <el-col :span="4" v-if="allow.adminCanEdit">
        <div style="margin-bottom: 30px">
          <el-button type="text" class="submit" @click="addTarget">{{$t("message.add")}}</el-button>
        </div>
      </el-col>
    </el-row>
    <el-table :data="tabledata" border style="width: 100%">
      <el-table-column prop="targetYear" align="center" :label="$t('page.PartnerTargets.targetYear')" width="110px" />
      <el-table-column prop="salesVolumeTarget" align="center" width="161px" :label="$t('page.PartnerTargets.salesVolumeTarget')" />
      <el-table-column prop="targetRegistered" align="center" :label="$t('page.PartnerTargets.targetRegistered')" :render-header="renderheader" />
      <el-table-column prop="targetCertified" align="center" :label="$t('page.PartnerTargets.targetCertified')" :render-header="renderheader" />
      <el-table-column prop="date" align="center" :label="$t('page.PartnerTargets.createTime')" width="110px">
        <template slot-scope="scope">
          {{getUTCtime(scope.row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column prop="date" align="center" :label="$t('message.Operation')" width="100px" v-if="allow.adminCanEdit">
        <template slot-scope="scope">
          <el-button type="text" @click="editTarget(scope.row)">{{$t("message.Edit")}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="targetFormTitle" :visible.sync="targetFormVisible" width="40%" center>
      <el-form :model="targetForm" ref="dialogForm" :rules="targetRules" label-width="310px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="id" prop="id" v-if="false">
              <el-input v-model="targetForm.id" auto-complete="off" disabled />
            </el-form-item>
            <el-form-item label="documentId" prop="documentId" v-if="false">
              <el-input v-model="targetForm.documentId" auto-complete="off" :disabled="!this.newRecord" />
            </el-form-item>
            <el-form-item :label="$t('page.PartnerTargets.targetYear')" prop="targetYear">
              <el-input v-model="targetForm.targetYear" :disabled="!newRecord" auto-complete="off" />
            </el-form-item>
            <el-form-item :label="$t('page.PartnerTargets.salesVolumeTarget')" prop="salesVolumeTarget">
              <el-input-number  :controls="false" v-model="targetForm.salesVolumeTarget" :min="0" style="width: 100%;text-align: left" />
              <span style="position: absolute;font-size: 12px;top: 1px;right : 8px;">{{$t("page.VAD.Targetunt")}}</span>
            </el-form-item>
            <el-form-item :label="$t('page.PartnerTargets.targetRegisteTitle')" prop="targetRegistered">
              <el-input-number  :controls="false" v-model="targetForm.targetRegistered" :min="0" style="width: 100%;text-align: left" />
            </el-form-item>
            <el-form-item :label="$t('page.PartnerTargets.targetCertifTitle')" prop="targetCertified">
              <el-input-number  :controls="false" v-model="targetForm.targetCertified" :min="0" style="width: 100%;text-align: left" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="targetFormVisible = false">{{$t("message.cancel")}}</el-button>
        <el-button type="primary" @click="saveTarget">{{$t("message.submit")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import API from "../../api"
  import {formate} from "../../utils/mixin"

  export default {
    name: "PartnerTargets",
    mixins: [formate],
    data() {
      return {
        tabledata: [],
        targetForm: {
          id: null,
          documentId: "",
          targetYear: new Date().getFullYear(),
          salesVolumeTarget: 0,
          targetRegistered: 0,
          targetCertified: 0,
        },
        newRecord: true,
        targetFormVisible: false,
        targetFormTitle: this.$t("message.targetEdit"),
      };
    },
    props:{
      allow:{
        type:Object,
        default:function(){
          return {};
        }
      }
    },
    methods: {
      init() {
        let id = this.$route.query.documentId;
        if (id) {
          this.getTargetsData(id);
        }
      },
      getTargetsData(id) {
        API.getTargetsByContract(id).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.tabledata = json.data;
          }
        }).catch(e => {
          console.error(e);
        })
      },
      addTarget() {
        this.newRecord = true;
        this.targetFormVisible = true;
        this.targetFormTitle = this.$t("message.targetAdd");
        this.clearForm();
      },
      editTarget(row) {
        this.newRecord = false;
        this.targetFormTitle = this.$t("message.targetEdit");
        this.targetFormVisible = true;
        this.targetForm.id = row.id;
        this.targetForm.documentId = row.documentId;
        this.targetForm.targetYear = row.targetYear;
        this.targetForm.salesVolumeTarget = row.salesVolumeTarget;
        this.targetForm.targetRegistered = row.targetRegistered;
        this.targetForm.targetCertified = row.targetCertified;
      },
      saveTarget() {
        this.$refs["dialogForm"].validate((valid) => {
          if (valid) {
            if (this.newRecord) {
              this.targetForm.documentId=this.$route.query.documentId;
              //新增
              API.addPartnerTarget(this.targetForm).then(res=>{
                let json=res.data;
                if (json.status === '200'){
                  this.targetFormVisible = false;
                  this.clearForm();
                  this.init();
                  this.$notify({
                    title: this.$t("message.submitsuccess"),
                    type: 'success'
                  });
                }
              }).catch(e=>{
                console.error(e);
              });
            } else {
              //编辑
              API.updatePartnerTarget(this.targetForm).then(res=>{
                let json=res.data;
                if (json.status === '200'){
                  this.targetFormVisible = false;
                  this.clearForm();
                  this.init();
                  this.$notify({
                    title: this.$t("message.submitsuccess"),
                    type: 'success'
                  });
                }
              }).catch(e=>{
                console.error(e);
              });
            }
          }
        });
      },
      checkYear(rule, value, callback) {
        let yearPattern = /^(?:19[7-9]\d|2\d{3})(?=\D|$)/;
        if (!yearPattern.test(value)) {
          callback(new Error(this.$t("message.targetyearinvalid")));
        }
        callback();
      },
      checkTarget(rule, value, callback) {
        let targetPattern = /^[+]?(\d+)$/;
        if (!targetPattern.test(value)) {
          callback(new Error(this.$t("message.numeric")));
        }
        callback();
      },
      clearForm(){
        this.targetForm = {
          id: null,
          documentId: "",
          targetYear: new Date().getFullYear(),
          salesVolumeTarget: 0,
          targetRegistered: 0,
          targetCertified: 0
        }
      }
    },
    computed: {
      targetRules() {
        return {
          targetYear: [
            {required: true, message: this.$t("message.targetyearnotnull"), trigger: 'blur'},
            {validator: this.checkYear, trigger: 'blur'}
          ],
          salesVolumeTarget: [
            {required: true, validator: this.checkTarget, trigger: 'blur'}
          ],
          targetRegistered: [
            {required: true, validator: this.checkTarget, trigger: 'blur'}
          ],
          targetCertified: [
            {required: true, validator: this.checkTarget, trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
      this.init();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/channelUserCen/PartnerTargets.vue